import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { OutreachInbox } from "@/components/app/outreach-inbox";

export const Route = createFileRoute("/_authenticated/outreach")({
  head: () => ({
    meta: [
      { title: "Inbox | Warrior Volunteer" },
      {
        name: "description",
        content: "Your outreach conversations, replies, and follow-ups in one inbox.",
      },
      { property: "og:title", content: "Inbox | Warrior Volunteer" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      {
        property: "og:description",
        content: "Your outreach conversations, replies, and follow-ups in one inbox.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: OutreachPage,
});

function OutreachPage() {
  return (
    <AppShell eyebrow="Volunteer" title="Inbox" dense containViewport>
      <OutreachInbox scope="mine" />
    </AppShell>
  );
}
